<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div fxLayout="column">
  <app-image-url-item
    *ngIf="extendedImageItem.image.type === TaskDatumType.IMAGE_URL"
    [imageItem]="extendedImageItem.image"
  >
  </app-image-url-item>
  <div
    *ngIf="extendedImageItem.image.type !== TaskDatumType.IMAGE_URL"
    class="image_container"
    fxLayoutAlign="center center"
  >
    <img [src]="imagePath" style="height: 160px" />
  </div>
  <span>{{ description }}</span>
</div>
